import { isValidObjectId } from "@/lib/utils/input-validator";
import { handleErrorServer, ServerError } from "@/lib/api/errors/ErrorHandler";
import {
  createGuestLog as createGuestLogApi,
  getGuestLogs as getGuestLogsApi,
  updateGuestLog as updateGuestLogApi,
} from "@/lib/api/clients/GuestLogClient";
import { parseString } from "@/lib/utils/parser";
import { GuestLog } from "@/types/GuestLog";

export async function getGuestLogs(
  eventId: string,
  guestId: string
): Promise<GuestLog[] | ServerError> {
  try {
    if (!isValidObjectId(eventId)) throw new Error("validationError");
    if (!isValidObjectId(guestId)) throw new Error("validationError");


    return await getGuestLogsApi(
      eventId,
      guestId,
      // `actorType` (FW12) is what tells the timeline an automation made the
      // change — the actor NAME is resolved server-side from `users` and an
      // automation has no user row, so without it the row shows no actor at
      // all. Must also be on the backend's ALLOWED_GUEST_LOG_FIELDS or it is
      // stripped from the projection before it is ever read.
      // `details` (SMS channel wave): an SMS_SENT row carries its facts there
      // ({sentSmsId, parts, workflowId}) — the timeline reads the part count.
      // `seatNumber`/`seatRow` (seats.io slice 1): the PRINTED seat a SEATED /
      // UNSEATED / SEATING_CHECK_IN row recorded. Same rule — asked for by
      // name or never loaded; an older backend drops the unknown names and
      // the timeline keeps `newValue + 1`. `seatBlock`/`seatArea` (seats.io
      // Teil 2, Zug 3): the piece's block and area on the same rows, written
      // only when the piece had a block — same rule again.
      "guestLogId,guestId,companionId,field,oldValue,newValue,createdAt,userId,type,importName,actorType,details,seatNumber,seatRow,seatBlock,seatArea",
    );
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function createGuestNote(
  eventId: string,
  guestId: string,
  note: string
): Promise<GuestLog | ServerError> {
  try {
    const parsedString = parseString(note.trim(), "");
    if (!isValidObjectId(eventId)) throw new Error("validationError");
    if (!isValidObjectId(guestId)) throw new Error("validationError");
    if (!parsedString) throw new Error("validationError");


    return await createGuestLogApi(
      eventId,
      guestId,
      parsedString,
    );
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function updateGuestNote(
  eventId: string,
  guestLogId: string,
  note: string
): Promise<void | ServerError> {
  try {
    const parsedString = parseString(note.trim(), "");
    if (!isValidObjectId(eventId)) throw new Error("validationError");
    if (!isValidObjectId(guestLogId)) throw new Error("validationError");
    if (!parsedString) throw new Error("validationError");


    return await updateGuestLogApi(
      eventId,
      guestLogId,
      parsedString,
    );
  } catch (error) {
    return handleErrorServer(error);
  }
}
